import React, { PureComponent, Fragment } from 'react'
import styles from './Title.scss'

export default class Title extends PureComponent {
  render() {
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <h2>{this.props.children}</h2>
      </Fragment>
    )
  }
}
